// recycle-rubber products (5 items)
export const productsRubberFlooring = [
  // === NEW ROUND 2 PRODUCTS ===
  {
    id: 16,
    slug: "elements-100-series",
    name: "Elements 100 Series",
    variant: "Recycled Rubber Flooring",
    type: "Recycled Rubber Flooring",
    category: "Recycle Rubber Flooring",

    categoryId: "recycle-rubber",    productSheetPdf: "/Assets/pdf/elements-100-series/PS_ISS_Elements100Series.pdf",
    techSpecsPdf: "/Assets/pdf/elements-100-series/PS_TechSpecs_100Series.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 10,
    sizeFormat: "Rolls",
    zones: [3],
      industries: ["Fitness Centers & Gymnasiums"],
      colorTones: ["black", "multi-color", "red", "green", "blue", "grey", "brown", "tan", "earth-tones", "neutral"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/100-series/thumbnail.jpg",
    heroImage: "/Assets/images/products/100-series/S100_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "SBR Rubber",
      construction: "SBR Rubber Black + % Color EPDM/Recycled Rubber",
      backing: "SBR Rubber",
      thickness: "0.15625 inch - 0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue-down or interlock",
      recommendedZone: "Zone 3",
      bestUseCase: "Gyms, Ice Rinks"
    },
    keyFeatures: [
      "Versatile and customizable recycled rubber flooring",
      "Superior slip resistance in wet or dry conditions",
      "Provides shock absorption and noise reduction"
    ],
    gallery: [
      "/Assets/images/products/100-series/100series_rink.jpg",
      "/Assets/images/products/100-series/100series_spinning.jpg",
      "/Assets/images/products/100-series/100series_interlocking.jpg",
      "/Assets/images/products/100-series/100series_rollgoods.jpg",
      "/Assets/images/products/100-series/100series_yellowmoon.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/100-series/Swatches/Black.jpg" },
      { name: "Blue", image: "/Assets/images/products/100-series/Swatches/Blue.jpg" },
      { name: "Blue Light Grey", image: "/Assets/images/products/100-series/Swatches/Blue-Light-Grey.jpg" },
      { name: "Green", image: "/Assets/images/products/100-series/Swatches/Green.jpg" },
      { name: "Light Grey", image: "/Assets/images/products/100-series/Swatches/Light-Grey.jpg" },
      { name: "Purple Rain", image: "/Assets/images/products/100-series/Swatches/Purple-Rain.jpg" },
      { name: "Red", image: "/Assets/images/products/100-series/Swatches/Red.jpg" },
      { name: "Tan Clay", image: "/Assets/images/products/100-series/Swatches/Tan-Clay.jpg" },
      { name: "Terra Cotta", image: "/Assets/images/products/100-series/Swatches/Terra-Cotta.jpg" },
      { name: "Yellow Moon", image: "/Assets/images/products/100-series/Swatches/Yellow-Moon.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you're responsible for specifying flooring that needs to perform year after year, you need a solution that can handle heavy use without constant maintenance or replacement. The problem is that many products wear down quickly, fail under pressure, or are difficult to install correctly costing you time and money.",
      "Elements 100 Series is built for extreme durability and is trusted in applications across the United States. Precision machine-cut rolls ensure exacting standards and make installation simple and efficient. With Elements 100 Series, you can install with confidence and know your flooring will stand up to demanding environments for the long haul."
    ],
    features: [
      "Versatile and customizable recycled rubber flooring",
      "Superior slip resistance in wet or dry conditions",
      "Provides shock absorption and noise reduction"
    ],
    specifications: {
      backing: "Premium Rubber Backing provides superior grip and dimensional stability",
      customization: "Available in custom shapes and sizes",
      application: "Indoor use only"
    }
  },
{
      id: 33,
      slug: "elements-200-series-rrf",
      name: "Elements 200 Series",
      variant: "Recycled Rubber Flooring",
      type: "Recycled Rubber Flooring",
      category: "Recycle Rubber Flooring",

    categoryId: "recycle-rubber",
      productSheetPdf: "/Assets/pdf/elements-200-series-rrf/PS_ISS_Elements200Series.pdf",
    techSpecsPdf: "/Assets/pdf/elements-200-series-rrf/PS_TechSpecs_200Series.pdf",
      saleSheetPdf: "/Assets/pdf/elements-200-series-rrf/PS_ISS_Elements200Series.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 8,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Fitness Centers & Gymnasiums"],
      colorTones: ["black", "multi-color", "red", "green", "blue", "grey", "brown", "tan", "earth-tones", "neutral"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/elements-200-series-rrf/elements-200-series-rrf_thumbnail.jpg",
      heroImage: "/Assets/images/products/elements-200-series-rrf/elements-200-series-rrf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "SBR Rubber",
      construction: "SBR Rubber Black + % Color EPDM/Recycled Rubber",
      backing: "SBR Rubber",
      thickness: "0.15625 inch - 0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue-down or interlock",
      recommendedZone: "Zone 3",
      bestUseCase: "Gyms, Ice Rinks"
    },
      keyFeatures: ["The highest quality rubber gym flooring available", "May qualify for LEED credits as part of a green building project", "Our EPDM color granules are made from 30-100% post-consumer"],
      gallery: ["/Assets/images/products/elements-200-series-rrf/elements-200-series-rrf_gallery_1.jpg", "/Assets/images/products/elements-200-series-rrf/200series_cannedheat.jpg", "/Assets/images/products/elements-200-series-rrf/200series_crushednuts.jpg", "/Assets/images/products/elements-200-series-rrf/200series_snowflakes.jpg", "/Assets/images/products/elements-200-series-rrf/200series_application_lifestyle.jpg"],
      swatches: [
        {name: "Blue Pool", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_BluePool-528.jpg"},
        {name: "Orange", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_Orange-527.jpg"},
        {name: "Snow Flakes", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_SnowFlakes-511.jpg"},
        {name: "Titan Grey", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_TitanGrey-512.jpg"},
        {name: "Crushed Nuts", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_CrushedNuts-508.jpg"},
        {name: "Gold Rush", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_GoldRush-529.jpg"},
        {name: "Canned Heat", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_CannedHeat-509.jpg"},
        {name: "Blue", image: "/Assets/images/products/elements-200-series-rrf/swatches/S200_Blue-507.jpg"}
      ],
      isPlaceholder: false,
      description: "Facilities need rubber flooring that can handle intense use without breaking down over time. Elements 200 Series delivers extreme durability with recycled rubber construction designed for demanding environments like fitness centers and training spaces. Engineered to provide reliable shock absorption and firm support underfoot, it helps protect both equipment and athletes. Made with high-quality rubber and EPDM color granules containing 30–100% post-consumer recycled content, Elements 200 Series offers one of the toughest and most sustainable rubber gym flooring solutions available.",
      features: ["The highest quality rubber gym flooring available", "May qualify for LEED credits as part of a green building project", "Our EPDM color granules are made from 30-100% post-consumer"],
      specifications: {}
    },
  {
      id: 34,
      slug: "elements-350-series-rrf",
      name: "Elements 350 Series",
      variant: "Recycled Rubber Flooring",
      type: "Recycled Rubber Flooring",
      category: "Recycle Rubber Flooring",

    categoryId: "recycle-rubber",
      productSheetPdf: "/Assets/pdf/elements-350-series-rrf/PS_ISS_Elements350Series.pdf",
    techSpecsPdf: "/Assets/pdf/elements-350-series-rrf/PS_TechSpecs_350Series.pdf",
      saleSheetPdf: "/Assets/pdf/elements-350-series-rrf/PS_ISS_350Series.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 7,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Fitness Centers & Gymnasiums"],
      colorTones: ["black", "multi-color", "red", "green", "blue", "grey", "brown", "tan", "earth-tones", "neutral"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/elements-350-series-rrf/thumbnail.jpg",
      heroImage: "/Assets/images/products/elements-350-series-rrf/elements-350-series-rrf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "SBR Rubber",
      construction: "SBR Rubber Black + % Color EPDM/Recycled Rubber",
      backing: "SBR Rubber",
      thickness: "0.15625 inch - 0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue-down or interlock",
      recommendedZone: "Zone 3",
      bestUseCase: "Gyms, Ice Rinks"
    },
      keyFeatures: ["The highest quality rubber gym flooring available", "May qualify for LEED credits as part of a green building project", "Our EPDM color granules are made from 30-100% post-consumer"],
      gallery: ["/Assets/images/products/elements-350-series-rrf/350series_yellow_gym.jpg", "/Assets/images/products/elements-350-series-rrf/350series_rouge_gym.jpg", "/Assets/images/products/elements-350-series-rrf/350series_tan2.jpg", "/Assets/images/products/elements-350-series-rrf/350series_grassgreen.jpg", "/Assets/images/products/elements-350-series-rrf/350series_milkyway.jpg"],
      swatches: [
        {name: "Rouge", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_Rouge-524.jpg"},
        {name: "Grass Green", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_GrassGreen-522.jpg"},
        {name: "Blue Bahia", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_BlueBahia-523.jpg"},
        {name: "Fiesta Purple", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_FlestaPurple-525.jpg"},
        {name: "Milky Way", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_MilkyWay-503.jpg"},
        {name: "Terrific Tan", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_TerrificTan-505.jpg"},
        {name: "Salt & Pepper", image: "/Assets/images/products/elements-350-series-rrf/swatches/S350_SaltPepper-526.jpg"}
      ],
      isPlaceholder: false,
      description: "Facilities that want the durability of high-performance rubber flooring with a more dynamic visual impact can rely on Elements 350 Series. Built with the same strength and resilience as the Elements 100 and 200 Series, it delivers dependable shock absorption and long-term performance in demanding fitness environments. Enhanced with vibrant EPDM color granules made from 30–100% post-consumer recycled content, Elements 350 Series adds energy to a space while remaining easy to maintain and capable of contributing to LEED- focused building projects.",
      features: ["The highest quality rubber gym flooring available", "May qualify for LEED credits as part of a green building project", "Our EPDM color granules are made from 30-100% post-consumer"],
      specifications: {}
    },
  {
      id: 35,
      slug: "elements-950-series-rrf",
      name: "Elements 950 Series",
      variant: "Recycled Rubber Flooring",
      type: "Recycled Rubber Flooring",
      category: "Recycle Rubber Flooring",

    categoryId: "recycle-rubber",
      productSheetPdf: "/Assets/pdf/elements-950-series-rrf/PS_ISS_Elements950Series.pdf",
    techSpecsPdf: "/Assets/pdf/elements-950-series-rrf/PS_TechSpecs_950Series.pdf",
      saleSheetPdf: "/Assets/pdf/elements-950-series-rrf/PS_ISS_950Series.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 9,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Fitness Centers & Gymnasiums"],
      colorTones: ["black", "multi-color", "red", "green", "blue", "grey", "brown", "tan", "earth-tones", "neutral"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/elements-950-series-rrf/elements-950-series-rrf_thumbnail.jpg",
      heroImage: "/Assets/images/products/elements-950-series-rrf/elements-950-series-rrf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "SBR Rubber",
      construction: "SBR Rubber Black + % Color EPDM/Recycled Rubber",
      backing: "SBR Rubber",
      thickness: "0.15625 inch - 0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Glue-down or interlock",
      recommendedZone: "Zone 3",
      bestUseCase: "Gyms, Ice Rinks"
    },
      keyFeatures: ["The highest quality rubber gym flooring available", "Easy Maintenance"],
      gallery: ["/Assets/images/products/elements-950-series-rrf/elements-950-series-rrf_hero.jpg", "/Assets/images/products/elements-950-series-rrf/elements-950-series-rrf_gallery_1.jpg", "/Assets/images/products/elements-950-series-rrf/950series_avalanche.jpg", "/Assets/images/products/elements-950-series-rrf/950series_gulfblue.jpg"],
      swatches: [
        {name: "Metal In Mud", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_MetalInMud_424-2.jpg"},
        {name: "Shooting Star", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_ShootingStat_424-52.jpg"},
        {name: "Volcanic Ash", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_VolcanicAsh_424-54.jpg"},
        {name: "Avalanche", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_Avalanche_424-4.jpg"},
        {name: "Volcanic Flow", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_VolcanicFlow_424-10.jpg"},
        {name: "Grizzly", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_Grizzly_424-17.jpg"},
        {name: "Gulf Blue", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_GulfBlue_424-51.jpg"},
        {name: "Granite Grey", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_GraniteGrey_424-7.jpg"},
        {name: "Tempe Sunset", image: "/Assets/images/products/elements-950-series-rrf/swatches/S950_TempeSunset_424-19.jpg"}
      ],
      isPlaceholder: false,
      description: "Facilities need gym flooring that can handle heavy equipment while maintaining a cleaner, quieter training environment. Elements 950 Series delivers a high- performance solution with dense recycled rubber designed for durability and sound absorption. Engineered to resist moisture and support antimicrobial performance, it helps create a more hygienic and resilient fitness space. Made from 100% recycled rubber tires and post-industrial EPDM color chips, Elements 950 Series combines sustainability, easy maintenance, and the strength required to stand up to the toughest gym environments.",
      features: ["The highest quality rubber gym flooring available", "Easy Maintenance"],
      specifications: {}
    },
  {
      id: 54,
      slug: "monster-tile-100-350-950-series-rrf",
      name: "Monster Tile – 100-350-950 Series",
      variant: "Recycled Rubber Flooring",
      type: "Recycled Rubber Flooring",
      category: "Recycle Rubber Flooring",

    categoryId: "recycle-rubber",
      productSheetPdf: "/Assets/pdf/monster-tile-100-350-950-series-rrf/PS_ISS_MonsterTile.pdf",
    techSpecsPdf: "/Assets/pdf/monster-tile-100-350-950-series-rrf/PS_TechSpecs_MonsterTileSeries.pdf",
      saleSheetPdf: "/Assets/pdf/monster-tile-100-350-950-series-rrf/PS_ISS_MonsterTile.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 17,
      sizeFormat: "Tiles",
      zones: [3],
      industries: ["Fitness Centers & Gymnasiums"],
      colorTones: ["black", "multi-color", "red", "green", "blue", "grey", "brown", "tan", "earth-tones", "neutral"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/thumbnail.jpg",
      heroImage: "/Assets/images/products/monster-tile-100-350-950-series-rrf/monster-tile-100-350-950-series-rrf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "SBR Rubber",
      construction: "SBR Rubber Black + % Color EPDM/Recycled Rubber",
      backing: "SBR Rubber",
      thickness: "1 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Dowels used to connect pieces, loose lay",
      recommendedZone: "Zone 3",
      bestUseCase: "Gyms, Ice Rinks"
    },
      keyFeatures: ["A classic combination of performance & design", "Standard Square Tile Dimensions is 24\u201d x 24\u201d x 1\u201d"],
      gallery: ["/Assets/images/products/monster-tile-100-350-950-series-rrf/monstertile_close_detail.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monstertile_deadlift.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monstertile_strength_facility.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monstertile_crossfit_studio.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monstertile_side.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monstertile_dumbbells_gym.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monster-tile-100-350-950-series-rrf_gallery_2.jpg", "/Assets/images/products/monster-tile-100-350-950-series-rrf/monster-tile-100-350-950-series-rrf_gallery_3.jpg"],
      swatches: [
        {name: "Storm Cloud", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_StormCloud-952.jpg"},
        {name: "Hot Chocolate", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_HotChocolate-953.jpg"},
        {name: "Mica", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_Mica-951.jpg"},
        {name: "Sandstone", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_Sandstone-956.jpg"},
        {name: "Avalanche", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_Avalanche-4244.jpg"},
        {name: "Granite Grey", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_GraniteGrey-4247.jpg"},
        {name: "Graphite", image: "/Assets/images/products/monster-tile-100-350-950-series-rrf/swatches/MT_Graphite-954.jpg"}
      ],
      isPlaceholder: false,
      description: "High-impact training areas demand flooring that can absorb punishment without compromising performance. Monster Rubber Tiles provide a heavy-duty solution with ultra-thick construction designed to protect subfloors from dropped weights while reducing noise and vibration throughout the facility. Their dense rubber composition delivers reliable shock absorption and long-term durability, while the modular tile format makes installation and maintenance simple. The result is a resilient gym flooring system built to handle the toughest training environments.",
      features: ["A classic combination of performance & design", "Standard Square Tile Dimensions is 24\u201d x 24\u201d x 1\u201d"],
      specifications: {}
    },
];
